import {
  BLOCK_CARD_SUCCESS,
  UNBLOCK_CARD_SUCCESS,
  BLOCKUNBLOCK_CARD_FAILED,
  BLOCKUNBLOCK_CARD_INVALID_REQUEST,  BLOCKUNBLOCK_CARD_NOT_FOUND,
  LOADING_BLOCKUNBLOCK_CARD,
  RESET_BLOCKUNBLOCK_CARD
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  invalidRequest: false,
  isBlocked: false,
  notFound: false,
  status: ""
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_BLOCKUNBLOCK_CARD:
      return {
        ...state,
        isLoading: true,
        failed: false,
        invalidRequest: false,
        notFound: false,
        status: ""
      };
    case BLOCKUNBLOCK_CARD_FAILED:
      return {
        ...state,
        isLoading: false,
        failed: true,
        invalidRequest: false,
        isBlocked: false,
        notFound: false,
        status: action.payload.status
      };
    case BLOCKUNBLOCK_CARD_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        failed: false,
        invalidRequest: true,
        isBlocked: false,
        notFound: false,
        status: action.payload.status
      };

    case BLOCKUNBLOCK_CARD_NOT_FOUND:
      return {
        ...state,
        isLoading: false,
        failed: false,
        invalidRequest: false,
        isBlocked: false,
        notFound: true,
        status: action.payload.status
      };

    case BLOCK_CARD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        failed: false,
        invalidRequest: false,
        isBlocked: true,
        notFound: false,
        status: action.payload
      };

    case UNBLOCK_CARD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        failed: false,
        invalidRequest: false,
        isBlocked: false,
        notFound: false,
        status: action.payload
      };

    case RESET_BLOCKUNBLOCK_CARD:
      return {
        ...state,
        isLoading: false,
        failed: false,
        invalidRequest: false,
        notFound: false,
        status: ""
      };

    default:
      return state;
  }
};
